<section class="feat pb-100" id="features" #section>
  <div class="container">
    <div class="row">
      <div class="col-md-8 centerize-col text-center feat-head">
        <div class="section-title">
          <p class="design-eyebrow brand-mark">{{ 'home.design.features' | translate }}</p>
          <h2 class="feature-title" [appSplitText]="'home.design.featuresTitle' | translate"></h2>
        </div>
        <p></p>
      </div>
    </div>
    <div class="row mt-50 feat-row" #row>
      <svg class="feat-wires" aria-hidden="true" focusable="false" #wires></svg>
      <div class="col-md-4 d-flex align-items-center">
        <div class="d-block">
          <div
            *ngFor="let service of leftServices; let isLast = last; trackBy: trackByIndex"
            class="feat-item text-start mt-50 sm-text-center xs-text-center"
            data-side="l"
          >
            <h5 class="mt-0 font-600">{{ service.title | translate }}</h5>
            <p class="font-300">{{ service.desc | translate }}</p>
            <div class="custom-separator" *ngIf="!isLast"></div>
          </div>
        </div>
      </div>
      <div class="col-md-4 feature feat-hub" #hub>
        <span class="feat-glow" aria-hidden="true"></span>
        <img
          class="img-responsive feature-img"
          src="assets/images/brand/logomark-purple.svg"
          alt=""
        />
      </div>
      <div class="col-md-4 d-flex align-items-center">
        <div class="d-block">
          <div
            *ngFor="let service of rightServices; let isLast = last; trackBy: trackByIndex"
            class="feat-item text-start mt-50 sm-text-center xs-text-center"
            data-side="r"
          >
            <h5 class="mt-0 font-600">{{ service.title | translate }}</h5>
            <p class="font-300">{{ service.desc | translate }}</p>
            <div class="custom-separator" *ngIf="!isLast"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
